<template>
    <v-app id="app">

        <v-layout row>

            <v-flex lg12>

                <v-row justify-lg="end" justify-sm="start" class="ml-lg-12 ml-1 mt-lg-12 mt-2">

                    <v-col cols="1" lg="6" xs="12">

                        <v-row style="width:300px !important;">
                             <v-col lg="10" xs="12">   <v-autocomplete
                                v-model="month"
                                :items="months"
                                item-text="month"
                                item-value="no"
                                dense
                                class="ml-lg-0"
                                prepend-icon="mdi-calendar"
                                label="SELECT MONTH"
                                @change="getReview()"
                            
                            ></v-autocomplete>  </v-col>

                        </v-row>

                    </v-col>

                </v-row>
                
                
                <v-data-table :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" dense :headers="headers" :items-per-page="itemPerPage" hide-default-footer :items="tables" item-key="name" class="elevation-0 table-rating">
                 
                             <template slot="item" slot-scope="props">

                                        <tr >
                                            <td class="text-left"> {{props.item.name}} </td>
                                            <td class="text-left"> {{props.item.tutorCount == 0 ? "0/20" :Math.round(parseFloat(parseInt(props.item.score)/parseInt(props.item.tutorCount))/parseInt(20)*20)+"/20"}} </td>
                                            

                                        </tr>

                                    </template>


                </v-data-table> 

            </v-flex>
        
        </v-layout>


    </v-app>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
    name:'monthlyReviewReport',
    
    data: () => ({
        month:'',
        months: [{'no':'01','month':'January'}, {'no':'02','month':'February'}, {'no':'03','month':'March'}, {'no':'04','month':'April'}, {'no':'05','month':'May'}, {'no':'06','month':'June'}, {'no':'07','month':'July'}, {'no':'08','month':'August'}, {'no':'09','month':'September'}, {'no':'10','month':'October'}, {'no':'11','month':'November'}, {'no':'12','month':'December'},],
        tables:[],
        getTutor:[],
        itemPerPage:0,
        timestamp: new Date(),
    }),
    computed: {
       headers(){ return  [{

          
          text: 'Tutor Name',
          align: 'left',
          sortable: false,
          value: 'name',
          class: "grey lighten-2"
        },
        { text: 'Score',align: 'left', value: 'score' , class: "grey lighten-2", sortable: false,},
        
        ]}
    },
    mounted(){
        this.getOtheTutor()
    },
    methods:{
        getOtheTutor(){
      
        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        .then(response=>{
        
          let tutorlist = response.data
          this.itemPerPage = tutorlist.length
              for(let i = 0 ; i<=tutorlist.length ; i++){
                    
                  
                  this.getTutor.push(tutorlist[i].tutor_id)
                  this.tables.push({
                                    id:tutorlist[i].tutor_id,
                                    name:tutorlist[i].tutor_full_name,
                                    score:0,
                                    lastVal:0,
                                    tutorCount: 0
                                    })
                 this.tables.sort(function(a, b){
                              return a.name.localeCompare(b.name);
                            })
                    

               }
               
              })

      },

      getReview(){

            
             for(let y = 0 ; y < this.tables.length ; y++){

                 this.tables[y].score = 0
                 this.tables[y].tutorCount = 0


             }
            this.getReviewProcess()

      },

     getReviewProcess(){
        
         let month_year = this.timestamp.getFullYear()+"-"+this.month+"-01"   

            axios.get('http://localhost/megatalking/performance/tutorperf.php?actionTaken=getManagerReview&month_year='+month_year)
                .then(response=>{


                    let data  = response.data

                    for(let x = 0 ; x < data.length ; x++){
                        
                       

                        for(let y = 0 ; y < data[x].scores.length ; y++){

                            this.tables[y].tutorCount = (x+1)
                            this.tables[y].score = Math.round(parseInt(data[x].scores[y].score)+parseInt(this.tables[y].score))
                        }


                    }


                }).catch(error=>console.log('this is the error '+error))

      },
 }
}
</script>
<style scoped>

</style>